import { useContext } from 'react';
import { VerificationWizardContext, type VerificationWizardContextType } from './VerificationWizardContext';

export function useVerificationWizard(): VerificationWizardContextType {
  const context = useContext(VerificationWizardContext);
  if (!context) {
    throw new Error('useVerificationWizard must be used within a VerificationWizardProvider');
  }
  return context;
}
